import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import style from "src/Assets/css/LandingPage/Switch.module.css";
import Tab from "../Tab";
import { SignupContext } from "src/context/SignupContext/SignupContext";
import { useSelector } from "react-redux";

const TabSwitch = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [selectedLabel, setSelectedLabel] = useState(
    props?.children[0]?.props?.label || "",
  );
  const signupContext = useContext(SignupContext);
  const emailAction = useSelector((state) => state.emailActionReducer);

  const updateTab = (label) => {
    setSelectedLabel((prev) => (prev === label ? prev : label));
  };

  useEffect(() => {
    const signInLabel = props?.children[0]?.props?.label;
    const joinNowLabel = props?.children[1]?.props?.label;

    const searchParams = new URLSearchParams(location.search);
    const hasSignInQuery =
      searchParams.get("goToSignIn") === "true" ||
      searchParams.get("signIn") === "true";

    const isOtpAction = emailAction?.action === "otp";
    // NEW: OTP email should open Join Now only for a new/temp user.
    // Existing Skopic users should go to Sign In.
    if (isOtpAction) {
      if (props.emailStatus === "SkopicUser") {
        updateTab(signInLabel);
      } else {
        updateTab(joinNowLabel);
      }

      return;
    }

    // 1️⃣ Highest Priority → force Sign In (navigation)
    if (location.state?.goToSignIn || hasSignInQuery) {
      updateTab(signInLabel);

      if (location.state?.goToSignIn) {
        history.replace({
          ...location,
          state: {},
        });
      }
      return;
    }

    // 2️⃣ Invite Flow handling
    if (props.isInviteFlow) {
      if (props.emailStatus === "SkopicUser") {
        updateTab(signInLabel);
        return;
      } else {
        updateTab(joinNowLabel);
        return;
      }
    }

    // 3️⃣ Signup Context → Join Now
    if (
      signupContext?.signupState?.signup ||
      signupContext?.signupState?.googleSignUp ||
      signupContext?.signupState?.appleSignUp
    ) {
      updateTab(joinNowLabel);
      return;
    }

    // 4️⃣ Default → Sign In
    updateTab(signInLabel);
  }, [
    props.emailStatus,
    props.isInviteFlow,
    signupContext?.signupState?.signup,
    signupContext?.signupState?.googleSignUp,
    signupContext?.signupState?.appleSignUp,
    location.state?.goToSignIn,
    location.search,
    emailAction?.action
  ]);

  const onClickTabItem = (tab) => {
    history.replace({});
    setSelectedLabel(tab);
    signupContext?.resetSignupState();
  };

  return (
    <>
      <div className={style.tabs}>
        <div className={style.tablist}>
          {props?.children.map((child) => {
            const { label } = child.props;

            return (
              <Tab
                activeTab={selectedLabel}
                key={label}
                label={label}
                onClick={onClickTabItem}
              />
            );
          })}
        </div>
        <div className="tab-content">
          {props?.children.map((child) => {
            if (child.props.label !== selectedLabel) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    </>
  );
};
export default TabSwitch;
